window.bundleDataZ = {
"Zachary-boy": {
displayName: "Zachary",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zachary Personalized Coloring Experience",
variantId: "49400115298541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zachary_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Zachary Dragon Holographic Sticker",
variantId: "49933770195181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zachary_holographic_sticker.png?v=1780106105",
price: "$4.99",
preorder: false
},
{
title: "Zachary Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Zara-girl": {
displayName: "Zara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zara Personalized Coloring Experience",
variantId: "49666595684589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zara_final_cover.png?v=1773592233",
price: "$14.99",
preorder: true
},
{
title: "Zara Unicorn Holographic Sticker",
variantId: "49933754204397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zara_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Zara Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Zoe-girl": {
displayName: "Zoe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zoe Personalized Coloring Experience",
variantId: "49666686025965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zoe_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Zoe Unicorn Holographic Sticker",
variantId: "49933754040557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zoe_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Zoe Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Zoey-girl": {
displayName: "Zoey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zoey Personalized Coloring Experience",
variantId: "49666607743213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zoey_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Zoey Unicorn Holographic Sticker",
variantId: "49933754171629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zoey_holographic_sticker.png?v=1780099046",
price: "$4.99",
preorder: false
},
{
title: "Zoey Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Zion-boy": {
displayName: "Zion",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zion Personalized Coloring Experience",
variantId: "50126141194477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zion_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Zion Dragon Holographic Sticker",
variantId: "50127077441773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zionstickerwebsite.png?v=1781967957",
price: "$4.99",
preorder: false
},
{
title: "Zion Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Zayden-boy": {
displayName: "Zayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zayden Personalized Coloring Experience",
variantId: "50180899963117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zayden_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Zayden Dragon Holographic Sticker",
variantId: "50180796514541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zaydenwebsitesticker.png?v=1782610309",
price: "$4.99",
preorder: false
},
{
title: "Zayden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Zane-boy": {
displayName: "Zane",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zane Personalized Coloring Experience",
variantId: "50449697407213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zane_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Zane Dragon Holographic Sticker",
variantId: "50449597333741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zane_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Zane Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Zuri-girl": {
displayName: "Zuri",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Zuri Personalized Coloring Experience",
variantId: "50643931758829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zuri_final_cover.png?v=1788490620",
price: "$14.99",
preorder: true
},
{
title: "Zuri Unicorn Holographic Sticker",
variantId: "50643947651309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Zuri_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Zuri Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 






};